import { Timeframe } from '@ankr.com/chains-list';
import { createContext } from 'react';

export interface TimeframeContextValue {
  timeframe: Timeframe;
  setTimeframe: (timeframe: Timeframe) => void;
}

const defaultValue: TimeframeContextValue = {
  timeframe: Timeframe.Day,
  setTimeframe: () => {},
};

export const TimeframeContext = createContext(defaultValue);
